import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import PlaceholdImage from "../../PlaceholdImage";

import "./ProductHeroIISlide.scss";

const ProductHeroIISlide = (props) => (
  <figure className="ProductHeroIISlide">
    {props.caption && (
      <figcaption
        className={cx("ProductHeroIISlide__caption", {
          "ProductHeroIISlide__caption--inverse": props.invert,
        })}
      >
        {props.caption}
      </figcaption>
    )}
    <PlaceholdImage image={props.image} noLazyLoad={props.index === 0} />
  </figure>
);

ProductHeroIISlide.propTypes = {
  caption: PropTypes.string,
  invert: PropTypes.bool,
  index: PropTypes.number.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    dimensions: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    }),
  }).isRequired,
};

export default ProductHeroIISlide;
